import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "flex gap-x-4" }
const _hoisted_3 = { class: "font-semibold text-20px whitespace-nowrap text-black-lp-200 capitalize" }
const _hoisted_4 = { class: "px-1 pb-6 border-b border-gray-lp-400" }
const _hoisted_5 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_6 = {
  key: 3,
  class: "space-y-6 mb-24 pr-1 overflow-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_PRCard = _resolveComponent("PRCard")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", {
      class: "fixed right-0 h-full z-20",
      style: 
        `background-color:rgba(0,0,0,0.3); top: 9rem; width: calc(100% - ${
          _ctx.isAdvancedFilterOpened && _ctx.isCollapseSidebar ? `60px` : `264px`
        });`
      
    }, null, 4), [
      [_vShow, _ctx.isAdvancedFilterOpened]
    ]),
    _createVNode(_component_Header, { class: "items-center" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$route?.meta.name), 1),
          _createVNode(_component_Search, {
            onInput: _ctx.onSearch,
            onClear: _ctx.clearSearch,
            value: _ctx.searchValue,
            style: {"width":"260px"},
            placeholder: "Cari No STT atau No Kendala"
          }, null, 8, ["onInput", "onClear", "value"]),
          (_ctx.isAbleToAdvanceFilter)
            ? (_openBlock(), _createBlock(_component_AdvancedFilter, {
                key: 0,
                "model-value": _ctx.advancedFilterData,
                isPeriode: "",
                periodeTitle: "",
                isCustomDropdown: "",
                titleCustomDropdown: "Urutkan",
                customDropdownList: _ctx.ticketSort,
                isDisabled: false,
                onChange: _ctx.onChangeAdvancedFilter,
                onOpened: _ctx.onOpenedAdvancedFilter,
                onReset: _ctx.onResetAdvancedFilter,
                addSumFilter: _ctx.addSumFilter
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('pusatResolusi.columnCategory')), 1),
                    _createVNode(_component_CustomDropdown, {
                      isExpand: _ctx.categoryOpened,
                      "onUpdate:isExpand": _cache[1] || (_cache[1] = ($event: any) => (_ctx.categoryOpened = $event)),
                      options: _ctx.categroies,
                      onSelect: _ctx.setCategories,
                      placeholder: _ctx.$t('pusatResolusi.choose'),
                      class: "w-full custom-select",
                      isCustomWidth: "",
                      selectedItem: _ctx.advancedFilterData.category
                    }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
                  ])
                ]),
                _: 1
              }, 8, ["model-value", "customDropdownList", "onChange", "onOpened", "onReset", "addSumFilter"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.ableToCreate)
          ? (_openBlock(), _createBlock(_component_lp_button, {
              key: 0,
              onClick: _ctx.toCreate,
              title: _ctx.$t('pusatResolusi.laporkanKendala'),
              textColor: "white"
            }, null, 8, ["onClick", "title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Tabs, {
      modelValue: _ctx.activeMenu,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeMenu = $event)),
      onChange: _ctx.onChangeTabs,
      data: _ctx.tabs,
      class: "mt-4"
    }, {
      default: _withCtx(() => [
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.onRequest,
              class: "mt-12"
            }, null, 8, ["errorType", "onTryAgain"]))
          : (!_ctx.listData.data.length && !_ctx.isFirstRequest)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 1,
                errorType: "notfound",
                onTryAgain: _ctx.onRequest,
                class: "mt-12"
              }, null, 8, ["onTryAgain"]))
            : (!_ctx.listData.data.length && _ctx.isFirstRequest)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 2,
                  class: "mt-12",
                  data: _ctx.$t('pusatResolusi.dataResolution'),
                  customHeaderMessage: _ctx.$t('pusatResolusi.noReportedIssue'),
                  customMessage: _ctx.$t('pusatResolusi.ifYouHaveIssue')
                }, null, 8, ["data", "customHeaderMessage", "customMessage"]))
              : (_openBlock(), _createBlock("div", _hoisted_6, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData.data, (item, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode(_component_PRCard, { data: item }, null, 8, ["data"])
                    ]))
                  }), 128))
                ])),
        (_ctx.listData.data.length > 0)
          ? (_openBlock(), _createBlock(_component_PaginationV3, {
              key: 4,
              pagination: _ctx.listData.pagination,
              "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listData.pagination = $event)),
              onSetPage: _ctx.toPageV3,
              renderedData: _ctx.listData.data.length,
              paginationWidth: "w-full",
              class: "absolute bottom-0"
            }, null, 8, ["pagination", "onSetPage", "renderedData"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onChange", "data"])
  ]))
}